import axios from './http'

export const Post = async (url, params, headers) => {
    return await axios.post(url, params, headers)
        .then((result) => {
            // 200系
            return {
                statusCode: String(result.status),
                response: result.data
            }
        })
        .catch((error) => {
            // 200系以外は全部こっち
            if (error.response) {
                return {
                    statusCode: String(error.response.status),
                    requestId: String(error.response.data.requestId),
                    response: String(error.response.data.message)
                }
            } else {
                return {
                    statusCode: 'レスポンス受信失敗',
                    requestId: '',
                    response: String(error.message)
                }
            }
        })
}

export const Get = async (url, headers) => {
    return await axios.get(url, headers)
        .then((result) => {
            // 200系
            return {
                statusCode: String(result.status),
                response: result.data
            }
        })
        .catch((error) => {
            // 200系以外は全部こっち
            if (error.response) {
                return {
                    statusCode: String(error.response.status),
                    requestId: String(error.response.data.requestId),
                    response: String(error.response.data.message)
                }
            } else {
                return {
                    statusCode: 'レスポンス受信失敗',
                    requestId: '',
                    response: String(error.message)
                }
            }
        })
}

export const Put = async (url, params, headers) => {
    return await axios.put(url, params, headers)
        .then((result) => {
            // 200系
            return {
                statusCode: String(result.status),
                response: result.data
            }
        })
        .catch((error) => {
            // 200系以外は全部こっち
            if (error.response) {
                return {
                    statusCode: String(error.response.status),
                    requestId: String(error.response.data.requestId),
                    response: String(error.response.data.message)
                }
            } else {
                return {
                    statusCode: 'レスポンス受信失敗',
                    requestId: '',
                    response: String(error.message)
                }
            }
        })
}

export const Delete = async (url, headers) => {
    return await axios.delete(url, headers)
        .then((result) => {
            // 200系
            return {
                statusCode: String(result.status),
                response: result.data
            }
        })
        .catch((error) => {
            // 200系以外は全部こっち
            if (error.response) {
                return {
                    statusCode: String(error.response.status),
                    requestId: String(error.response.data.requestId),
                    response: String(error.response.data.message)
                }
            } else {
                return {
                    statusCode: 'レスポンス受信失敗',
                    requestId: '',
                    response: String(error.message)
                }
            }
        })
}
